



























































import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { ThgMeterReadingGen } from "@/services/thg/v1/data-contracts";
import { Component, Prop } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import Card from "../utility/Card.vue";
import Debug from "../utility/Debug.vue";

@Component({ components: { Debug, LatestEntriesCardEmpty, Card } })
export default class ThgBillingSelectionItemMeterReadingData extends DarkModeHighlightMixin {
  @Prop()
  meterReading!: ThgMeterReadingGen;

  get width() {
    if (this.$vuetify.breakpoint.smAndDown) {
      return "100%";
    } else {
      return "250px";
    }
  }

  loading = true;

  locked = true;

  toggleLock = () => {
    this.locked = !this.locked;
  };
}
